<script setup>
import BackgroundSection from "./BackgroundSection.vue";
import content from "../content.js";

const about = content.about;
</script>

<template>
    <BackgroundSection
        section-id="about"
        :video="about.video"
        :image="about.image"
        overlay-class="bg-gradient-to-b from-black/60 via-black/40 to-black/60"
        extra-class="text-center flex items-center justify-center"
    >
        <div class="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
            <div
                class="bg-gradient-to-b from-black/70 via-black/60 to-black/70 backdrop-blur-[40px] rounded-2xl p-6 sm:p-8 shadow-2xl"
            >
                <h2
                    class="text-shadow text-2xl sm:text-4xl md:text-5xl font-bold mb-6 sm:mb-8 text-gray-50 drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)]"
                    data-aos="fade-up"
                >
                    {{ about.title }}
                </h2>

                <p
                    v-for="(paragraph, i) in about.text"
                    :key="i"
                    :class="[
                        'text-glow',
                        'text-gray-200 text-base sm:text-2xl md:text-2xl font-medium leading-relaxed mb-6 sm:mb-8',
                    ]"
                    data-aos="fade-up"
                    :data-aos-delay="150 * i"
                >
                    {{ paragraph }}
                </p>
            </div>
        </div>
    </BackgroundSection>
</template>

<style scoped>
.text-glow {
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.8);
}
</style>
